/**
 * The domain colour and icon of a group of facts (dview:domain on its sh:PropertyGroup), from dim-ui's
 * --dim-domain-<id> tokens. The colours are for edges, dots, icon tiles and drawings, never for text;
 * location and validity are both blue, so the icon always goes with the colour.
 */

import { Bolt, CalendarClock, EmergencyHome, Key, LocationOn, Settings, Speed, Stacks, TrendingUp, ArrowRange } from '@bn-apps/design-system-icons';
import type { IconComponent } from '@bn-apps/dim-ui-react';

export const DOMAINS = {
  identification: { color: 'var(--dim-domain-identification)', icon: Key },
  location: { color: 'var(--dim-domain-location)', icon: LocationOn },
  kind: { color: 'var(--dim-domain-kind)', icon: ArrowRange },
  geometry: { color: 'var(--dim-domain-geometry)', icon: TrendingUp },
  speed: { color: 'var(--dim-domain-speed)', icon: Speed },
  energy: { color: 'var(--dim-domain-energy)', icon: Bolt },
  safety: { color: 'var(--dim-domain-safety)', icon: EmergencyHome },
  contents: { color: 'var(--dim-domain-contents)', icon: Stacks },
  validity: { color: 'var(--dim-domain-validity)', icon: CalendarClock },
  technical: { color: 'var(--dim-domain-technical)', icon: Settings },
} satisfies Record<string, { color: string; icon: IconComponent }>;

export type DomainId = keyof typeof DOMAINS;

export const domainOf = (id: string | undefined | null): (typeof DOMAINS)[DomainId] | null =>
  id && id in DOMAINS ? DOMAINS[id as DomainId] : null;
